import React from 'react';
import AboutSection from '../components/AboutSection';

const About = () => {
  return (
    <section className="about" id="about">
 
      <AboutSection/>
    
    </section>
  );
};

export default About;
